import service from '@/api';
import { GlobalStore } from '@/store';

/**  성장판 모니터링 로그 등록  */
export const monitoringLog = async (params) => {
    const gStore = GlobalStore();
    console.log('gStore.loginRoot ===', gStore.loginRoot);
    if (gStore.loginRoot === 'growthplate') {
        try {
            const res = await service({
                url: `/api/growth/monitoring/log`,
                method: 'post',
                data: params,
            });
            return res;
        } catch (e) {
            return e.response ? e.response : null;
        }
    }
};

export const monitoringTodayLearningStudy = async (params) => {
    try {
        const res = await service({
            url: `/api/growth/learning/readyToTodayStudy`,
            method: 'post',
            data: params,
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

export const monitoringEndDiagnosticStudy = async (params) => {
    try {
        const res = await service({
            url: `/api/growth/diagnostic/readyToTodayStudy`,
            method: 'post',
            data: params,
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};
